import React, { FC } from 'react';
import { IProduct, TDiscountStyle } from 'mod/product/interface';
import { tagsConfig } from 'mod/product/config';
import { getDiscountText, getTagElStyles } from 'mod/product/utils';
import { TAG_FLASHSALE } from 'mod/product/constant';
import { IStyleConfig } from 'base/interfacesV2/feature';
import Image from '@base/lib/ThemeImage';
import cn from 'classnames';
import styles from './index.module.less';
import { useTrans } from 'base/utils/i18n';

type IProductTagProps = {
    tagConfig?: IStyleConfig;
    discount?: IProduct['discount'];
    discountStyle?: TDiscountStyle;
    className?: string;
};


type ITagConfig = {
    tagConfig?: IStyleConfig;
    defaultConfig?: { text: string, icon: string };
    discount?: IProduct['discount'];
    discountStyle?: TDiscountStyle;
}


// 两行模式
const Tag_Vertical_Layout = 'vertical' // vertical、horizontal、pic

// 图片模式
const TitleImage: FC<ITagConfig> = (props) => {
    const { tagConfig } = props
    const { image, imgHeight = 16, imgWidth = 78 } = tagConfig || {}

    return (
        <Image
            fixed
            background={false}
            src={image}
            width={imgWidth}
            height={imgHeight}
        />
    )
}

// title
const TitleText: FC<ITagConfig> = (props) => {
    const { tagConfig, defaultConfig } = props
    const { icon, title } = tagConfig || {}
    const { t } = useTrans();

    const _styles = getTagElStyles(tagConfig)?.titleStyle

    return (
        <div className={'g-tag-text flex'} style={_styles}>
            {/* 配置 false 不展示icon > 取接口配置 > 取默认配置*/}
            {!!icon && (
                <Image
                    className={styles.icon}
                    fixed
                    background={false}
                    src={icon}
                    width={12}
                    height={12}
                />
            )}

            <span>{title || t(defaultConfig?.text || '') || ''}</span>
        </div>
    )
}

// 折扣
const DescText: FC<ITagConfig> = (props) => {
    const { tagConfig, discount, discountStyle } = props
    const { desc, tagType } = tagConfig || {}

    return (
        <div className={'g-off-line'} style={getTagElStyles(tagConfig)?.descStyle}>
            {(tagType?.toLowerCase() === TAG_FLASHSALE && discount) ? getDiscountText(discount, discountStyle) : (desc || '')}
        </div>
    )
}

export const ProductTag: FC<IProductTagProps> = props => {
    const { tagConfig, discount, className, discountStyle } = props;
    const tagType = tagConfig?.tagType?.toLowerCase() || ''
    const defaultConfig = tagsConfig.product[tagType];

    const isImage = tagConfig?.image && tagConfig.layout == 'pic';

    const { layout = '', title, desc } = tagConfig || {}

    return (
        <div className={cn(className, 'tags-wrap', styles['tags-wrap'])}>
            <div
                className={cn(
                    { 'flex': layout !== Tag_Vertical_Layout }, // Tag_Vertical_Layout 两行模式
                    `g-tag-${tagType} g-tag-corner overflow`,
                )}
                style={isImage ? {} : getTagElStyles(tagConfig)?.wrapStyle}
            >

                {isImage ? (
                    <TitleImage tagConfig={tagConfig}/>
                ) : (
                    <>
                        {/* flashSale 空title 不展示，其他展示默认的 */}
                        {tagType?.toLowerCase() === TAG_FLASHSALE && !title ? (<></>) : (
                            <TitleText
                                tagConfig={tagConfig}
                                defaultConfig={defaultConfig}
                                discount={discount}
                                discountStyle={discountStyle}
                            />
                        )}

                        {tagType?.toLowerCase() === TAG_FLASHSALE || !!desc ? (
                            <DescText tagConfig={tagConfig} discount={discount} discountStyle={discountStyle}/>
                        ) : (<></>)}
                    </>)
                }
            </div>
        </div>

    )
};
